<template>
    <modal size="l" @close="reset(); $emit('close')" ref="modal" :is-closeable="isCloseable" id="editPositionPositionsModal" :autoshow="true" v-if="dataLoaded">
        <template v-slot:title>
            <h3 class="modal-title">Edit {{ editModePretty }}</h3>
        </template>

        <slot>
            <div class="mb-2">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">Company: </span>{{ position.company.name }}</div>
                    <div><span class="text-muted">Position: </span>{{ position.terminal_value }}</div>
                </div>
            </div>

            <form-errors :errors="formErrors"/>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <form v-if="editMode == 'info'">
                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="POS Value" v-model="formData.pos_value" :errors="errors.pos_value" type="text" :maxlength="100"/>
                                    </div>
                                    <div class="col-6">
                                        <form-input label="SOC Code" v-model="formData.soc_code" :errors="errors.soc_code" type="text" :maxlength="20"/>
                                    </div>
                                </div>

                                <template v-for="i in 5">
                                    <form-input v-if="i == client.location_org_level" label="Location" type="select" :options="locationOptions" v-model="formData.work_location" :errors="errors.work_location"/>
                                    <form-input v-else-if="orgOptionsByLevel[i] && orgOptionsByLevel[i].length" :label="client[`org_level_${i}_label`]" type="select" :options="orgOptionsByLevel[i]" v-model="formData[`org_level_${i}_value`]" :errors="errors[`org_level_${i}_value`]"/>
                                </template>

                                <form-input label="Pay Group" v-model="formData.paygroup" :errors="errors.paygroup" type="select" :options="paygroupOptions"/>

                                <!-- <div class="form-row">
                                    <div class="col-6">
                                        <form-input label="State" v-model="formData.state" :errors="errors.state" type="select" :options="stateOptions"/>
                                    </div>

                                    <div class="col-6">
                                        <form-input label="Zip Code" :maxlength="5" v-model="formData.postal_code" :errors="errors.postal_code" type="text" inputmode="tel" />
                                    </div>
                                </div> -->

                                <div class="form-row">
                                    <div class="col-6">
                                        <form-input v-model="formData.bank_account_net_pay" :errors="errors.bank_account_net_pay" label="Net Pay Bank Account" type="select" :options="bankAccountOptions" :noblank="true" />
                                    </div>

                                    <div class="col-6">
                                        <form-input v-model="formData.bank_account_taxes" :errors="errors.bank_account_taxes" label="Taxes Bank Account" type="select" :options="bankAccountOptions" :noblank="true" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            <earning-selector v-if="editMode == 'earnings'" v-model="formData.earning_types"/>
            <deduction-selector v-if="editMode == 'deductions'" v-model="formData.deduction_types"/>

        </slot>

        <template v-slot:footer>
            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">
                    Cancel
                </button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">
                    Save
                </button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'
import EarningSelector from '@/pages/client/Settings/components/EarningSelector'
import DeductionSelector from '@/pages/client/Settings/components/DeductionSelector'

export default {
    props: ['client', 'position', 'editMode'],
    mixins: [FormMixin, ModalMixin],
    components: {EarningSelector, DeductionSelector},
    data() {
        return {
            formData: this.makeFormData(),
            bankAccounts: null,
            orgs: null,
            locations: null,
            paygroups: null,
        }
    },
    mounted() {
        this.getData()
    },
    computed: {
        dataLoaded() {
            return this.bankAccounts && this.orgs && this.locations && this.paygroups
        },
        editModePretty() {
            return {
                'earnings': 'Earnings',
                'deductions': 'Deductions',
                'info': 'Information',
                '': '',
            }[this.editMode]
        },
        orgOptionsByLevel() {
            if (!this.dataLoaded) {return []}

            const result = {}
            for (let i = 1; i <= 5; i++) {
                result[i] = []
                this.orgs.filter(o => o.org_level == i).forEach(o => {
                    result[i].push({text: o.org_level_description, value: o.org_level_description})
                })

                result[i].sort((a, b) => {
                    return (a.text > b.text) ? 1 : -1
                })

            }

            return result
        },
        locationOptions() {
            if (!this.dataLoaded) {return []}

            const result = []
            this.locations.forEach(l => {
                result.push({text: l.name, value: l.id})
            })

            result.sort((a, b) => {
                return (a.text > b.text) ? 1 : -1
            })

            return result
        },
        paygroupOptions() {
            if (!this.dataLoaded) {return []}

            const result = []
            let paygroups = this.paygroups
            if (this.formData.work_location) {
                const location = this.locations.find(l => l.id == this.formData.work_location)
                paygroups = this.paygroups.filter(p => p.company_id == location.company_id)
            }
            paygroups.forEach(l => {
                result.push({text: l.name, value: l.id})
            })

            result.sort((a, b) => {
                return (a.text > b.text) ? 1 : -1
            })

            return result
        },
        bankAccountOptions() {
            if (!this.dataLoaded) {return []}

            const result = [
                {text: '--Default--', value: ''}
            ]

            this.bankAccounts.forEach(b => {
                result.push({text: b.name, value: b.id})
            })

            result.sort((a, b) => {
                if (!a.value) {return -1}
                if (!b.value) {return 1}
                return (a.text > b.text) ? 1 : -1
            })

            return result
        },

    },
    methods: {
        makeFormData() {
            const data = {
                earning_types: [],
                deduction_types: [],
                soc_code: this.position.soc_code,
                pos_value: this.position.pos_value,
                org_level_1_value: this.position.org_level_1_value,
                org_level_2_value: this.position.org_level_2_value,
                org_level_3_value: this.position.org_level_3_value,
                org_level_4_value: this.position.org_level_4_value,
                org_level_5_value: this.position.org_level_5_value,
                work_location: this.position.work_location_id,
                paygroup: this.position.paygroup.id,
                bank_account_net_pay: this.position.bank_account_net_pay_id,
                bank_account_taxes: this.position.bank_account_taxes_id,
            }

            this.position.earning_types.forEach(e => {
                data.earning_types.push(e.earning_type.id)
            })

            this.position.deduction_types.forEach(d => {
                data.deduction_types.push(d.deduction_type.id)
            })

            return data
        },
        getOrgs() {
            return this.$api.get(`/clients/${this.client.id}/settings/company-orgs`).then(resp => {
                this.orgs = resp
            })
        },
        getLocations() {
            return this.$api.get(`/clients/${this.client.id}/settings/locations`).then(resp => {
                this.locations = resp
            })
        },
        getPaygroups() {
            return this.$api.get(`/clients/${this.client.id}/settings/paygroups`).then(resp => {
                this.paygroups = resp
            })
        },
        getBankAccounts() {
            return this.$api.get(`/clients/${this.client.id}/settings/bank-accounts`).then(resp => {
                this.bankAccounts = resp.filter(b => b.company_id == this.position.company_id)
            })
        },
        getData() {
            this.$store.dispatch('START_LOADING')
            const promises = [
                this.getOrgs(),
                this.getLocations(),
                this.getPaygroups(),
                this.getBankAccounts(),
            ]

            Promise.all(promises).then(() => {
                this.$store.dispatch('STOP_LOADING')
            }).catch(err => {
                this.$store.dispatch('STOP_LOADING')
                this.$bus.showError('Could not load form. Please refresh the page and try again.')
            })
        },
        onSubmit() {
            this.$store.dispatch('START_LOADING')

            const URLS = {
                earnings: `/clients/${this.client.id}/settings/positions/${this.position.id}/earning-types`,
                deductions: `/clients/${this.client.id}/settings/positions/${this.position.id}/deduction-types`,
                info: `/clients/${this.client.id}/settings/positions/${this.position.id}`,
            }
            const url = URLS[this.editMode]
            if (!url) {return}

            return this.$api.patch(url, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.onError()
            })
        }
    }
}
</script>
